<template>
  <Form :ref="'form'+current" :model="form" :rules="rules" :label-width="165">
    <!-- <Divider orientation="left">学历信息</Divider> -->
    <Row :gutter="16">
      <Col span="24">
      <FormItem label="专科学历">
        <RadioGroup v-model.trim="form.maxEducationType" disabled @on-change="()=>{form.maxCNEducationType=null;isRequired1=false;isRequired2=false;isRequired3=false;isRequired4=false;}">
          <Radio disabled :label="value" v-for="{text,value} in $store.state.materiaBasicData.educationAreaType" :key="value">{{text}}</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
    </Row>
    <Row :gutter="16" v-show="form.maxEducationType==1" :key="form.maxCNEducationType">
      <Col span="24">
      <FormItem :key="form.maxCNEducationType" label="学历类型">
        <Select v-model.trim="form.maxCNEducationType" disabled placeholder="" style="width:100%" @on-change="isRequired">
          <Option v-for="{text,value}  in $store.state.materiaBasicData.cnEducationType" :value="value" :key="value">{{ text }}</Option>
        </Select>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="上传申请人专科学历证书">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">

            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.educationFileGuid">
              <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.educationFileGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.educationFileGuid)" type="ios-eye" />

                </i>
              </span>
              <!-- </template> -->
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem label="学历认证报告">
        <RadioGroup v-model.trim="form.educationCertReportType">
          <Radio :label="value" disabled v-for="{text,value} in $store.state.materiaBasicData.degreeCertReportType" :key="value">{{text}}</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <Col span="12" v-show="form.educationCertReportType==1">
      <FormItem label="上传教育部学籍在线证明报告">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">

            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.educationJYBCheckReportGuid">
              <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.educationJYBCheckReportGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.educationJYBCheckReportGuid)" type="ios-eye" />
                </i>
              </span>
              <!-- </template> -->
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col span="12" v-show="form.educationCertReportType==1">
      <FormItem label="上传教育部学历证书电子注册备案表">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">

            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.educationJYBRegFileGuid">
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.educationJYBRegFileGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.educationJYBRegFileGuid)" type="ios-eye" />
                </i>
              </span>
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col span="12" v-show="form.educationCertReportType==2">
      <FormItem label="书面学历认证报告">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">

            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.educationWrittenFileGuid">
              <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.educationWrittenFileGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.educationWrittenFileGuid)" type="ios-eye" />
                </i>
              </span>
              <!-- </template> -->
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
    </Row>
    <!-- 海外 -->
    <Row :gutter="16" v-show="form.maxEducationType===2">
      <Col span="24">
      <FormItem label="国（境）外学历学位认证证书" class="noticeTop">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">

            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.hW_EducationDegreeCertificationGuid">
              <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.hW_EducationDegreeCertificationGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.hW_EducationDegreeCertificationGuid)" type="ios-eye" />
                </i>
              </span>
              <!-- </template> -->
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>

          </div>
          </Col>

        </Row>
      </FormItem>
      <FormItem>
        <span class="notice">(教育部留学服务中心国外学历学位认证证书)</span>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem label="是否属于以下情况">
        <RadioGroup v-model.trim="form.hW_Situation" vertical>
          <!-- <Radio label="国外学历学位认证书的出具时间在2006年8月之前"></Radio>
          <Radio label="港澳地区学历学位认证书的出具时间在2006年8月之前"></Radio>
          <Radio label="中外合作办学学历学位认证书的出具时间在2006年8月之前"></Radio>
          <Radio label="不属于以上情况"></Radio> -->

          <Radio :label="value" disabled v-for="{text,value} in $store.state.materiaBasicData.situation" :key="value">{{text}}</Radio>

        </RadioGroup>
      </FormItem>
      </Col>
      <Col span="24" v-show="form.hW_Situation!=4">
      <FormItem label="是否已提交教育部留学服务中心更新后的认证书">
        <RadioGroup v-model.trim="form.hW_IsSubmitCertification">
          <Radio disabled :label="true">是</Radio>
          <Radio disabled :label="false">否</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <Col span="24" v-show="form.hW_IsSubmitCertification===false&&form.hW_Situation!=4">
      <FormItem label="认证书真伪查询回函">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">

            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.hW_QueryAuthenticityGuid">
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.hW_QueryAuthenticityGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.hW_QueryAuthenticityGuid)" type="ios-eye" />
                </i>
              </span>
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>

          </div>
          </Col>

        </Row>
      </FormItem>
      </Col>
    </Row>
    <!-- 信息详情 -->
    <Row :gutter="16">
      <Divider orientation="left">信息详情</Divider>
      <Col span="12">
      <FormItem label="入学时间">
        <DatePicker type="date" disabled :editable="false" v-model.trim="form.enrolDate" placeholder="" style="width: 100%" />
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="毕业时间">
        <DatePicker type="date" disabled :editable="false" v-model.trim="form.graduationDate" placeholder="" style="width: 100%" />
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="所学专业">
        <Input v-model.trim="form.speciality" disabled :maxlength="40" placeholder=""></Input>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="年制">
        <Input v-model.trim.number="form.studyYears" disabled placeholder="">
        <template #append>
          <span>年</span>
        </template>
        </Input>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="教育类型">
        <Select v-model.trim="form.teachingType" placeholder="" disabled style="width:100%">
          <Option v-for="{text,value} in $store.state.materiaBasicData.teachingType" :value="value" :key="value">{{ text }}</Option>
        </Select>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="学习形式">
        <Select v-model.trim="form.learningForms" placeholder="" disabled style="width:100%">
          <Option v-for="{text,value} in $store.state.materiaBasicData.learningForms" :value="value" :key="value">{{ text }}</Option>
        </Select>
      </FormItem>
      </Col>

      <Col span="12">
      <FormItem label="学历">
        <Select v-model.trim="form.educationType" placeholder="" disabled style="width:100%">
          <Option v-for="{text,value} in $store.state.materiaBasicData.educationType" :value="value" :key="value">{{ text }}</Option>
        </Select>
      </FormItem>
      </Col>

      <Col span="12">

      <FormItem class="noticeTop" label="学历证书编号">
        <Input v-model.trim="form.educationCertNo" :maxlength="40" disabled placeholder="" style="width: 100%">
        <template #prepend>
          <Tooltip placement="top-start" max-width="600" content="“学历证书编号”是指学历电子注册号码，有的叫学校编号，有的叫电子注册号，而不是证书印刷的流水号。">
            <span class="noticeIcon">!</span>
          </Tooltip>
        </template>
        </Input>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem class="" label="学历发证机构">
        <Input v-model.trim="form.educationCertAuthority" disabled :maxlength="40" placeholder="" style="width: 100%" />
      </FormItem>
      </Col>
      <!-- <Col span="24">
      <Row>
        <Col span="12">
        <FormItem class="noticeTop" label="学位">
          <Select v-model.trim="form.degreeType" placeholder="" disabled style="width:100%">
            <Option v-for="{text,value} in $store.state.materiaBasicData.degreeType" :value="value" :key="value">{{ text }}</Option>
          </Select>
        </FormItem>
        <FormItem class="notice">
          <div>
            注：如果没有学位证书，学位信息可不填写
          </div>
        </FormItem>
        </Col>
      </Row>
      </Col>
      <Col span="12">
      <FormItem label="学位证书编号">
        <Input v-model.trim="form.degreeCertNo" disabled :maxlength="40" placeholder="" style="width: 100%" />
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="学位发证机构">
        <Input v-model.trim="form.degreeCertAuthority" disabled :maxlength="40" placeholder="" style="width: 100%" />
      </FormItem>
      </Col> -->
      <!-- <Col span="12">
      <FormItem class="noticeTop" label="联系电话">
        <Input v-model.trim="form.contactPhone" disabled :maxlength="40" placeholder="请填写申请人联系电话" style="width: 100%">
        <template #prepend>
          <Tooltip placement="top-start" max-width="600" content="“联系电话”请填写积分申请人的电话，不是人事的电话。">
            <span class="noticeIcon">!</span>
          </Tooltip>
        </template>
        </Input>
      </FormItem>
      </Col> -->
      <!-- <Col span="12">
      <FormItem label="是否专升本">
        <RadioGroup v-model.trim="form.isZSB">
          <Radio disabled :label="true">是</Radio>
          <Radio disabled :label="false">否</Radio>
        </RadioGroup>
      </FormItem>
      </Col> -->
      <!-- isRequired2==true -->
      <Col span="12" v-show="isRequired2">
      <FormItem label="学生证">
        <!-- <Upload :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'cR_StudentIDCardGuidList',true)"
          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'cR_StudentIDCardGuidList',true)" :on-format-error="handleFormatError">
          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
        </Upload> -->
        <div class="_link" v-for="item in form.cR_StudentIDCardGuidListPreview" @click="handlePreview(item)" :key="item.guid">
          <Icon :type="item.name | fileType" />
          {{item.name}}
        </div>
        <span class='_noLink' v-if="form.cR_StudentIDCardGuidListPreview.length<1">无</span>
      </FormItem>
      </Col>
      <Col span="12" v-show="isRequired2">
      <FormItem label="学生登记表">
        <!-- <Upload :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'cR_StudentRegistrationGuidList',true)"
          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'cR_StudentRegistrationGuidList',true)" :on-format-error="handleFormatError">
          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
        </Upload> -->
        <div class="_link" v-for="item in form.cR_StudentRegistrationGuidListPreview" @click="handlePreview(item)" :key="item.guid">
          <Icon :type="item.name | fileType" />
          {{item.name}}
        </div>
        <span class='_noLink' v-if="form.cR_StudentRegistrationGuidListPreview.length<1">无</span>
      </FormItem>
      </Col>
      <Col span="12" v-show="isRequired2">
      <FormItem label="是否上海以外工作地报考">
        <RadioGroup v-model.trim="form.cR_IsNotInSHRegistration">
          <Radio :label="true" disabled>是</Radio>
          <Radio :label="false" disabled>否</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <Col span="12" v-show="isRequired2">
      <FormItem label="报考地社保材料">
        <!-- <Upload :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'cR_RegistrationSocialInsuranceGuidList',true)"
          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'cR_RegistrationSocialInsuranceGuidList',true)" :on-format-error="handleFormatError">
          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
        </Upload> -->
        <div class="_link" v-for="item in form.cR_RegistrationSocialInsuranceGuidListPreview" @click="handlePreview(item)" :key="item.guid">
          <Icon :type="item.name | fileType" />
          {{item.name}}
        </div>
        <span class='_noLink' v-if="form.cR_RegistrationSocialInsuranceGuidListPreview.length<1">无</span>
      </FormItem>
      </Col>
      <Col span="12" v-show="isRequired2">
      <FormItem label="报考地个税材料">
        <!-- <Upload :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'cR_RegistrationIndividualTaxGuidList',true)"
          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'cR_RegistrationIndividualTaxGuidList',true)" :on-format-error="handleFormatError">
          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
        </Upload> -->
        <div class="_link" v-for="item in form.cR_RegistrationIndividualTaxGuidListPreview" @click="handlePreview(item)" :key="item.guid">
          <Icon :type="item.name | fileType" />
          {{item.name}}
        </div>
        <span class='_noLink' v-if="form.cR_RegistrationIndividualTaxGuidListPreview.length<1">无</span>
      </FormItem>
      </Col>
      <!-- isRequired4==true -->
      <Col span="12" v-show="isRequired4">
      <FormItem class="noticeTop" label="参军现役证明材料">
        <!-- <Upload :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'jD_CertificationMaterialGuidList',true)"
          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'jD_CertificationMaterialGuidList',true)" :on-format-error="handleFormatError">
          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
        </Upload> -->
        <div class="_link" v-for="item in form.jD_CertificationMaterialGuidListPreview" @click="handlePreview(item)" :key="item.guid">
          <Icon :type="item.name | fileType" />
          {{item.name}}
        </div>
        <span class='_noLink' v-if="form.jD_CertificationMaterialGuidListPreview.length<1">无</span>
      </FormItem>
      <FormItem class="notice">
        提供转业证（退伍证、复员证）等能体现参军服役情况的有效证明材料。
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="其他材料">
        <!-- <Upload :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'otherFileGuidList',true)"
          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'otherFileGuidList',true)" :on-format-error="handleFormatError">
          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
        </Upload> -->
        <div class="_link" v-for="item in form.otherFileGuidListPreview" @click="handlePreview(item)" :key="item.guid">
          <Icon :type="item.name | fileType" />
          {{item.name}}
        </div>
        <span class='_noLink' v-if="form.otherFileGuidListPreview.length<1">无</span>
      </FormItem>
      </Col>
    </Row>

  </Form>
</template>
<script>
export default {
  props: { form: { type: Object }, current: { type: Number } },
  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      //   form: { id: 'ywlsh_12356789', kh: '新开户', sfzzm: [] },
      appInfoDataType: this.$store.state.appInfoDataType,
      uploadData: {},

      current_index: this.current,

      rules: {},
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
      isRequired1: false,
      isRequired2: false,
      isRequired3: false,
      isRequired4: false,
    }
  },
  watch: {
    'form.maxCNEducationType': {
      handler(val) {
        this.isRequired(val)
      },
    },
  },
  mounted() {
    this.isRequired(this.form.maxCNEducationType)
  },
  methods: {
    //下一步
    next(name, val) {
      let _this = this
      //上一步
      if (val < this.current) {
        // this.$emit('next', val)
        if (this.form.isChildrenEnjoyTreatment) {
          _this.$emit('next', _this.appInfoDataType['子女信息'])
          return
        }
        if (!this.form.isSpouseEnjoyTreatment) {
          _this.$emit('next', _this.appInfoDataType['申请人基本信息'])
          return
        }
        if (this.form.isSpouseEnjoyTreatment) {
          _this.$emit('next', _this.appInfoDataType['配偶信息'])
          return
        }
        return
      }
      //下一步
      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        this.$emit(
          'next',
          this.appInfoDataType['加分材料'],
          '/api/services/app/JZZJFApi/SaveAppEducationInfo'
        )
      })
    },
    //判断必填
    isRequired(val) {
      this.isRequired1 = false //普通高校 除其他材料，学位材料和学位认证材料，其他字段均为必填项
      this.isRequired2 = false //1、成人教育、网络教育、高等教育自学考试、开放教育，除了最高学历证书，及学历认证材料，其他均非必填项
      this.isRequired3 = false //2、高等教育自学考试  教育部学籍在线验证报告 非必传
      this.isRequired4 = false //军队院校成人教育、解放军高等教育自学考试、开放教育中的八一、总参学院 除了最高学历证书及学历认证材料，转业证（退伍证、复员证），其他均非必填项

      if (val == 1) {
        this.isRequired1 = true
      }
      if (val == 2 || val == 4 || val == 3 || val == 6) {
        this.isRequired2 = true
      }
      if (val == 3) {
        this.isRequired3 = true
      }
      if (val == 8 || val == 7 || val == 9) {
        this.isRequired4 = true
      }
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(response, file, fileList, property, isArray) {
      this.$emit('handleSuccess', response, file, fileList, property, isArray)
      this.$refs['form' + this.current].validateField(property)
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //预览
    handleView(guid) {
      this.$emit('handleView', guid)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
    //时间格式化
    // changeDateFmt(dateFmt, date, property) {
    //   this.$emit('changeDateFmt', dateFmt, date, property)
    // },
  },
}
</script>